import React from "react";
import { useTranslation } from "react-i18next";

import { HeaderText, SectionContainer, SectionSubtitle } from "../../../components/Modals";
import { Flex } from "../../../components/ui/Flex";
import ToggleInput from "../../../components/ui/ToggleInput";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "../../../components/ui/Form";
import { SettingsModalInput } from "../../settings/SettingsModals";

const CustomSettingFormInputs = ({ form }) => {
  const { t } = useTranslation();
  return (
    <SectionContainer>
      <HeaderText alt>{t('Custom Settings')}</HeaderText>
      <SectionSubtitle>{t('For custom workflows or integrations.')}</SectionSubtitle>
      <Flex direction="column" gap="16px">
        <ToggleInput
          form={form}
          name="enable_custom_service_request_categories"
          label={t('Enable Custom Work Request Categories')}
          description={t('Allow custom ticket types')}
        />

        <FormField
          control={form.control}
          name="service_request_url"
          render={({ field }) => (
            <FormItem alt>
              <FormLabel v3>{t('Work Request URL')}</FormLabel>
              <FormControl row>
                <SettingsModalInput
                  type="text"
                  placeholder={t('Paste integration or webhook URL')}
                  autoComplete="off"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="payment_redirect_url"
          render={({ field }) => (
            <FormItem alt>
              <FormLabel v3>{t('Payment Redirect URL')}</FormLabel>
              <FormControl row>
                <SettingsModalInput
                  type="text"
                  placeholder={t('Paste external URL for payments')}
                  autoComplete="off"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="notification_delay_device_down"
          render={({ field }) => (
            <FormItem alt>
              <FormLabel v3>{t('Device Down Notification Delay (Minutes)')}</FormLabel>
              <FormControl row>
                <SettingsModalInput
                  type="number"
                  placeholder={t('Enter delay in minutes')}
                  autoComplete="off"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </Flex>
    </SectionContainer>
  )
};

export default CustomSettingFormInputs;
